/* NodeEmpire Header: mobiles Menü (Drawer), Untermenüs, Höhen-Variablen, Land/Sprache. */
(function () {
  if (window.customElements.get('ne-header')) return;

  var FOCUSABLE = 'a[href],button:not([disabled]),select:not([disabled]),input:not([disabled]),[tabindex]:not([tabindex="-1"])';

  class NeHeader extends HTMLElement {
    connectedCallback() {
      this.drawer = this.querySelector('[data-ne-drawer]');
      this.burger = this.querySelector('[data-ne-open]');
      this.panel = this.querySelector('.ne-hd__panel');
      this.mq = window.matchMedia('(min-width: 1280px)');
      this.lastFocus = null;

      this.onClick = this.onClick.bind(this);
      this.onKey = this.onKey.bind(this);
      this.onDocClick = this.onDocClick.bind(this);
      this.onMq = this.onMq.bind(this);
      this.onChange = this.onChange.bind(this);
      this.measure = this.measure.bind(this);

      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKey);
      this.addEventListener('change', this.onChange);
      document.addEventListener('click', this.onDocClick);
      if (this.mq.addEventListener) this.mq.addEventListener('change', this.onMq);
      else if (this.mq.addListener) this.mq.addListener(this.onMq);

      this.measure();
      window.addEventListener('resize', this.measure);
      window.addEventListener('load', this.measure);
      if ('ResizeObserver' in window) {
        this.ro = new ResizeObserver(this.measure);
        this.ro.observe(this);
        var group = document.getElementById('header-group');
        if (group) this.ro.observe(group);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKey);
      this.removeEventListener('change', this.onChange);
      document.removeEventListener('click', this.onDocClick);
      if (this.mq) {
        if (this.mq.removeEventListener) this.mq.removeEventListener('change', this.onMq);
        else if (this.mq.removeListener) this.mq.removeListener(this.onMq);
      }
      window.removeEventListener('resize', this.measure);
      window.removeEventListener('load', this.measure);
      if (this.ro) this.ro.disconnect();
      document.documentElement.classList.remove('ne-hd-lock');
    }

    /* Höhe des Headers und der Header-Gruppe, die das Theme für Sticky-Elemente nutzt */
    measure() {
      var wrap = this.closest('.shopify-section') || this;
      var h = Math.round(wrap.getBoundingClientRect().height);
      var group = document.getElementById('header-group');
      var total = 0;
      if (group) {
        for (var i = 0; i < group.children.length; i++) {
          if (group.children[i] instanceof HTMLElement) total += group.children[i].offsetHeight;
        }
      }
      if (!total) total = h;
      document.body.style.setProperty('--header-height', h + 'px');
      document.body.style.setProperty('--header-group-height', total + 'px');
    }

    isOpen() {
      return !!(this.drawer && this.drawer.classList.contains('is-open'));
    }

    openDrawer() {
      if (!this.drawer || this.isOpen()) return;
      this.lastFocus = document.activeElement;
      this.drawer.hidden = false;
      void this.drawer.offsetWidth;
      this.drawer.classList.add('is-open');
      if (this.burger) {
        this.burger.setAttribute('aria-expanded', 'true');
      }
      document.documentElement.classList.add('ne-hd-lock');
      var self = this;
      window.setTimeout(function () {
        var first = self.panel && self.panel.querySelector('[data-ne-close]');
        if (first) first.focus();
        else if (self.panel) self.panel.focus();
      }, 30);
    }

    closeDrawer(restoreFocus) {
      if (!this.drawer || !this.isOpen()) return;
      var drawer = this.drawer;
      drawer.classList.remove('is-open');
      if (this.burger) this.burger.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('ne-hd-lock');
      var done = false;
      var finish = function () {
        if (done) return;
        done = true;
        if (!drawer.classList.contains('is-open')) drawer.hidden = true;
      };
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce) finish();
      else window.setTimeout(finish, 320);
      if (restoreFocus !== false) {
        var target = this.burger && this.burger.offsetParent !== null ? this.burger : this.lastFocus;
        if (target && target.focus) target.focus();
      }
    }

    toggleSub(btn) {
      var li = btn.closest('li');
      if (!li) return;
      var open = btn.getAttribute('aria-expanded') !== 'true';
      this.closeSubs(li);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      li.classList.toggle('is-open', open);
    }

    closeSubs(except) {
      var items = this.querySelectorAll('li.is-open');
      for (var i = 0; i < items.length; i++) {
        if (except && (items[i] === except || items[i].contains(except))) continue;
        items[i].classList.remove('is-open');
        var b = items[i].querySelector('[data-ne-sub]');
        if (b) b.setAttribute('aria-expanded', 'false');
      }
    }

    onClick(e) {
      var t = e.target;
      if (!(t instanceof Element)) return;
      var open = t.closest('[data-ne-open]');
      if (open && this.contains(open)) { e.preventDefault(); this.openDrawer(); return; }
      var close = t.closest('[data-ne-close]');
      if (close && this.contains(close)) { e.preventDefault(); this.closeDrawer(); return; }
      var sub = t.closest('[data-ne-sub]');
      if (sub && this.contains(sub)) { e.preventDefault(); this.toggleSub(sub); return; }
      /* Link im mobilen Menü: Menü schliessen (Ankerlinks auf derselben Seite) */
      var a = t.closest('.ne-hd__panel a[href]');
      if (a && this.isOpen()) {
        var href = a.getAttribute('href') || '';
        if (href.charAt(0) === '#') this.closeDrawer(false);
      }
    }

    onDocClick(e) {
      if (!this.contains(e.target)) this.closeSubs();
    }

    onChange(e) {
      var t = e.target;
      if (t && t.matches && t.matches('[data-ne-local]')) {
        var form = t.closest('form');
        if (form) form.submit();
      }
    }

    onMq() {
      if (this.mq.matches) {
        this.closeDrawer(false);
      }
      this.measure();
    }

    onKey(e) {
      if (e.key === 'Escape') {
        if (this.isOpen()) { e.preventDefault(); this.closeDrawer(); return; }
        var openSub = this.querySelector('.ne-hd__item.is-open');
        if (openSub) {
          var b = openSub.querySelector('[data-ne-sub]');
          this.closeSubs();
          if (b) b.focus();
        }
        return;
      }
      if (e.key === 'Tab' && this.isOpen() && this.panel) {
        var nodes = Array.prototype.filter.call(this.panel.querySelectorAll(FOCUSABLE), function (n) {
          return n.offsetParent !== null || n === document.activeElement;
        });
        if (!nodes.length) return;
        var first = nodes[0];
        var last = nodes[nodes.length - 1];
        if (e.shiftKey && (document.activeElement === first || document.activeElement === this.panel)) {
          e.preventDefault(); last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault(); first.focus();
        }
      }
    }
  }

  window.customElements.define('ne-header', NeHeader);
})();
